import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Dropdown, Image, Menu } from 'semantic-ui-react'
import { observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import './Header.css'
import AuthenticationStore from '../stores/AuthenticationStore'

@observer
class Header extends Component {
  static propTypes = {
    authenticationStore: PropTypes.instanceOf(AuthenticationStore).isRequired
  }

  handleLogout = () => {
    const { authenticationStore } = this.props
    authenticationStore.logout()
  }

  render () {
    const { loggedUser } = this.props.authenticationStore
    return (
      <>
        <Menu borderless className='top-header'>
          <Menu.Item fitted>
            <Image as={Link} to='/calendars' src='/img/mci/mci_logo_new.png' size='small' />
          </Menu.Item>
          <Menu.Menu position='right'>
            {loggedUser !== undefined &&
              <>
                <Dropdown
                  item
                  simple
                  direction='right'
                  text={`Bonjour ${loggedUser.fullName}`}
                >
                  <Dropdown.Menu>
                    {!loggedUser.isClient &&
                      <>
                        <Dropdown.Item as={Link} to='/profile'>Profil</Dropdown.Item>
                        <Dropdown.Divider />
                      </>}
                    <Dropdown.Item onClick={this.handleLogout}>Se déconnecter</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </>}
          </Menu.Menu>
        </Menu>
      </>
    )
  }
}

export default Header
